import gql from 'graphql-tag';

export const getChannelName = gql`
  query getChannelName($id: UUID!) {
    channel(_id: $id) {
      _id
      name
    }
  }
`;
